import React from "react";
import Error from "../ui/Error";
import Loading from "../ui/Loading";
import LeaderBoardResult from "./LeaderBoardResult";

export default function LeaderBoardResults({
  usersPosition,
  isLoading,
  isError,
  error,
}) {
  const numberOfUsersToshow = process.env.REACT_APP_LEADERBOARD_TOP_RESULT;

  // deciding what to render
  let content = null;
  if (isLoading) {
    content = (
      <tr>
        <td>
          <Loading />
        </td>
      </tr>
    );
  } else if (!isLoading && isError) {
    content = (
      <tr>
        <td>
          <Error message={error} />
        </td>
      </tr>
    );
  } else if (!isLoading && !isError && usersPosition?.length > 0) {
    content = usersPosition?.map((user) => {
      if (user?.position <= numberOfUsersToshow) {
        return <LeaderBoardResult key={user.id} user={user} />;
      } else {
        return false;
      }
    });
  }

  return (
    <div className="my-8">
      <h3 className="text-lg font-bold">Top {numberOfUsersToshow} Result</h3>
      <table className="text-base w-full border border-slate-600/50 rounded-md my-4">
        <thead>
          <tr className="border-b border-slate-600/50">
            <th className="table-th !text-center">Rank</th>
            <th className="table-th !text-center">Name</th>
            <th className="table-th !text-center">Quiz Mark</th>
            <th className="table-th !text-center">Assignment Mark</th>
            <th className="table-th !text-center">Total</th>
          </tr>
        </thead>

        <tbody>{content}</tbody>
      </table>
    </div>
  );
}
